const map = {
	"./AreaBuddy.png": 198,
	"./AreaBuddy_new.png": 353,
	"./animal care.jpg": 788,
	"./beauty care.jpg": 228,
	"./child care services.jpg": 148,
	"./construction.jpg": 152,
	"./driver services.jpg": 209,
	"./education services.jpg": 193,
	"./event services.jpg": 507,
	"./health & yoga.jpg": 927,
	"./home services.jpg": 696,
	"./laundry services.jpg": 922,
	"./legal services.jpg": 874,
	"./mechanic services.jpg": 581,
	"./medical services.jpg": 32,
	"./photography.jpg": 518,
	"./property care services.jpg": 757,
	"./rental services.jpg": 81,
	"./senior citizen care.jpg": 968,
	"./software developement.jpg": 262,
	"./travel services.jpg": 983
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 392;